import { render, staticRenderFns } from "./BugReportButton.vue?vue&type=template&id=1569c7ee&scoped=true"
import script from "./BugReportButton.vue?vue&type=script&lang=js"
export * from "./BugReportButton.vue?vue&type=script&lang=js"
import style0 from "./BugReportButton.vue?vue&type=style&index=0&id=1569c7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1569c7ee",
  null
  
)

export default component.exports